// TODO: Move to enums folder
export const envsEnum = Object.freeze({
    PRODUCTION: 'production',
    DEVELOPMENT: 'development',
    QA: 'qa',
    UAT: 'uat',
});
